/**
 * Returns a new designator sequencer based off of input nets map. The sequencer allows calling
 * code to obtain a sequentially unique designator (with respect to input nets map)
 *
 * @param netsMap
 * @returns designator e.g. "Net 1", "Net 2", etc.
 */
export function createNetDesignatorSequencer(netsMap) {
    // Local resuable helper used to ensure reliable string matching
    const homogenizeString = (value) => value.trim().toLowerCase();
    // Define the prefix used for all net designators
    const designatorPrefix = "Net ";
    // Obtain a flat list of unique designators from the input element map
    const designatorSet = new Set(Object.values(netsMap).map((net) => homogenizeString(net.label ?? "")));
    // Define the external API that allows calling code to obtain next
    // ordinal/sequential designator with respect to specified element
    // map
    function findNextDesignator() {
        // Perform linear search to find next unique designator
        for (let count = 1;; count++) {
            const designator = `${designatorPrefix}${count}`;
            if (!designatorSet.has(homogenizeString(designator))) {
                // A unique designator found, update the local set
                // of designators and return current unique designator
                // to caller
                designatorSet.add(homogenizeString(designator));
                return designator;
            }
        }
    }
    return {
        findNextDesignator,
    };
}
//# sourceMappingURL=netDesignator.js.map